'use client';
import React,{ useRef } from 'react';
import { motion, useInView, Variants } from 'framer-motion';

interface IQueueAnimateBox {
  children: React.ReactNode;
  className?: string;
  all?: boolean;
}
export const QueueAnimateBox = (props: IQueueAnimateBox) => {
  const { children, className, all } = props;
  const ref = useRef(null);
  const isInview = useInView(ref);
  const childrenMap = React.Children.map(children,((child, i) => (
    <QueueAnimateItem key={i}>{child}</QueueAnimateItem>
  )));
  return (
    <motion.div
      className={`w-full ${className}`}
      initial="hidden"
      animate={isInview ? 'visible' : 'hidden'}
      variants={container}
      ref={ref}
    >
      {all ? childrenMap : children}
    </motion.div>
  );
};

export const QueueAnimateItem = (props: IQueueAnimateItem) => {
  const { children, className, variants } = props;
  return (
    <motion.div className={className} variants={variants ? variants : item}>
      {children}
    </motion.div>
  );
};

const container: Variants = {
  hidden: { opacity: 0, scale: 1 },
  visible: {
    opacity: 1,
    scale: 1,
    transition: {
      delayChildren: 0.3,
      staggerChildren: 0.2,
    },
  },
};

interface IQueueAnimateItem {
  children: React.ReactNode;
  className?: string;
  variants?: Variants;
}

const item: Variants = {
  hidden: { y: 50, opacity: 0 },
  visible: {
    y: 0,
    opacity: 1,
    transition: {
      duration: 0.8,
    },
  },
};
